<template>
  <div id="app">
    <router-view class="container" :key="key" v-cloak />
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      width: 0
    }
  },
  created () {
    this.$store.commit('setUserInfo')
    this.$store.commit('_vm', this)
    window._vm = this
    this.$store.commit('getUserInfos')
  },
  computed: {
    key () {
      return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  height: 100%;
}
.container {
  width: 100%;
  height: 100%;
  /* background: #fff; */
  overflow-x: hidden;
  overflow-y: visible;
}
.el-scrollbar {
  height: 100%;
  overflow: hidden;
}
.el-scrollbar__wrap {
  overflow: hidden;
  overflow-y: scroll;
}
.el-scrollbar__thumb {
  background-color: #969494;
}
/* @media (min-width: 576px) {
  .container {
    max-width: 576px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
@media (min-width: 992px) {
  .container {
    max-width: 992px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
@media (min-width: 992px) {
  .container {
    max-width: 992px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1200px !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
} */
@media screen and (min-width: 240px) and (max-width: 320px) {
  div#login {
    div.loginBox {
      img {
        display: none;
      }
    }
  }
  div#register {
    div.regBox {
      img {
        display: none;
      }
    }
  }
}
@media screen and (min-width: 240px) and (max-width: 375px) {
  div#login {
    div.loginBox {
      top: 55%;
      align-items: flex-start;
      overflow: hidden;
      min-height: inherit;
      .userBox {
        width: 90%;
        margin: 0 auto;
      }
    }
  }
  div#register {
    div.regBox {
      top: 55%;
      min-height: inherit;
      align-items: flex-start;
      overflow: hidden;
      .userBox {
        width: 90%;
        margin: 0 auto;
      }
    }
  }
}
@media screen and (min-width: 240px) and (max-width: 480px) {
  #home #content {
    max-width: 90%;
    grid-template-columns: none !important;
  }
  #users div#content {
    width: calc(100% - 20px);
  }
  div#app #content .left {
    width: 100%;
    padding-right: 0;
  }
  .van-pagination {
    width: 100%;
    margin: 0 auto;
    font-size: 12px;
  }
  div#app #content .right {
    display: none;
  }
  div#topNav .center .left #search_box {
    display: none;
  }
  div#topNav {
    .center {
      width: 90%;
    }
  }
  div#loginBox {
    width: 90%;
    img {
      width: 100%;
    }
    .userBox {
      width: 90%;
      margin: auto;
      .username, .pwd {
        width: 100%;
      }
    }
  }
  div#postDetails #content .left .particulars .info .other .time {
    flex-direction: column;
    align-items: start;
    margin-top: 6px;
    span {
      margin: 4px 0;
    }
  }
  div.v-note-wrapper .v-note-op {
    display: none;
  }
  div#comment {
    width: 95%;
  }
  div#login {
    min-width: 100%;
    .loginBox {
      top: 54%;
      overflow: hidden;
      width: 92%;
      flex-direction: column;
      max-height: inherit;
      img {
        width: 100%;
      }
      .userBox {
        margin: 0;
        img {
          display: none;
        }
      }
    }
  }
  div#register {
    min-width: 100%;
    .regBox {
      overflow: hidden;
      width: 92%;
      flex-direction: column;
      max-height: inherit;
      img {
        width: 100%;
      }
      .userBox {
        margin: 0;
        img {
          display: none;
        }
      }
    }
  }
  div#users #content {
     .left #menu {
      display: flex;
      height: 40px;
      margin: 0;
      justify-content: space-between;
      .item {
        width: auto;
        flex: 1;
        text-align: center;
        padding-right: 20px;
        &.active::before {
          height: 3px;
          bottom: 0;
          top: inherit;
          width: 100%;
        }
      }
    }
    .rights {
      width: 100%;
    }
  }
}
@media screen and (min-width: 480px) and (max-width: 768px) {
  #home main#content {
    max-width: 90%;
    grid-template-columns: none;
  }
  div#app #content .left {
    width: 100%;
    padding-right: 0;
  }
  .van-pagination {
    width: 100%;
    margin: 0 auto;
  }
  div#topNav .center .left #search_box {
    display: none;
  }
  div#app #content .right {
    display: none;
  }
  div#topNav {
    .center {
      width: 90%;
    }
  }
  div#login .loginBox {
    width: 454px;
    flex-direction: column;
    max-height: inherit;
    .userBox {
      margin: 0;
    }
  }
  div#register .regBox {
    width: 454px;
    flex-direction: column;
    max-height: inherit;
    .userBox {
      margin: 0;
    }
  }
  div#users #content {
     .left #menu {
      display: flex;
      .item {
        padding-right: 20px;
        &.active::before {
          height: 3px;
          bottom: 0;
          top: inherit;
          width: 100%;
        }
      }
    }
    .rights {
      width: 100%;
    }
  }
}
@media screen and (min-width: 768px) {
  #content {
    max-width: 90%;
  }
  .van-pagination {
    width: 50%;
    margin: 40px auto 0;
  }
  div#login .loginBox {
    width: 454px;
    flex-direction: column;
    max-height: inherit;
    .userBox {
      margin: 0;
    }
  }
  div#register .regBox {
    width: 454px;
    flex-direction: column;
    max-height: inherit;
    .userBox {
      margin: 0;
    }
  }
}
@media screen and (min-width: 992px) {
  #content {
    max-width: 992px;
  }
}
@media screen and (min-width: 1200px) {
  #content {
    max-width: 1200px;
  }
}
[v-cloak] {
  display: none;
}
mark {
  background: #e75151;
  color: #fff;
  padding: 2px 4px;
  border-radius: 4px;
  margin: 0 2px;
}
ul {
  list-style: unset;
}
ul ul {
          list-style: circle;
}
ul ul ul {
            list-style: square;
}
ul ul ul li {
              padding: 4px 0;
}
ol {
  list-style: decimal;
}
</style>



// WEBPACK FOOTER //
// src/App.vue